import styles from './BottomNavigation.module.sass'

interface BottomNavigationProps {
  children: React.ReactNode
}
export const BottomNavigation = ({ children }: BottomNavigationProps) => {
  return <div className={styles.bottomNavigationMenu}>{children}</div>
}
